export default "__VITE_ASSET__C59C0YcA__"